import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Rental reservations stats DTO
 */
@CaslSubject(AppSubjectEnum.RENTAL_RESERVATION)
export class RentalReservationsStatsDto extends BaseStatsDto {
  pending!: number;
  accepted!: number;
  rejected!: number;
}
